import { Exception } from '../../../core/logic/exception';

export class InvalidTranscriptionTypeException extends Exception<never> {
  constructor() {
    super('Type de fichier invalide, types acceptés: mp3/m4a/wav');
  }
}

export class TranscriptionTooBigException extends Exception<never> {
  constructor() {
    super('Taille de fichier trop importante, limite de 200Mo');
  }
}

export class TranscriptionNotFoundException extends Exception<never> {
  constructor() {
    super('Transcription non trouvée');
  }
}
